/**
 * Debug utility to check CSS variable values
 */

export function debugCSSVariables() {
	if (typeof window === 'undefined') return
	
	const root = document.documentElement
	const computedStyle = getComputedStyle(root)
	
	const variables = [
		'--background',
		'--foreground',
		'--primary',
		'--primary-foreground',
		'--secondary',
		'--secondary-foreground',
		'--accent',
		'--muted',
		'--card',
		'--popover',
		'--border',
		'--input',
		'--ring',
	]
	
	console.log('CSS Variable Values:')
	console.log('===================')
	
	variables.forEach(varName => {
		const value = computedStyle.getPropertyValue(varName).trim()
		console.log(`${varName}: ${value}`)
	})
	
	// Also check if the values are being parsed correctly
	console.log('\nParsed Colors:')
	console.log('==============')
	
	// Create temporary element to test color parsing
	const testEl = document.createElement('div')
	document.body.appendChild(testEl)
	
	variables.forEach(varName => {
		testEl.style.backgroundColor = `var(${varName})`
		const computed = getComputedStyle(testEl).backgroundColor
		console.log(`${varName} computed: ${computed}`)
	})
	
	document.body.removeChild(testEl)
}